module.exports = __webpack_public_path__ + "img/playstore.e37119c9.png";